import { useMutation } from 'react-query'

import { APIError } from '../../../../utils'
import { deleteAttachment } from '../../query-api'

interface UseDeleteAttachmentProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export const useDeleteAttachment = (props: UseDeleteAttachmentProps = {}) => {
  const { onError, onSuccess } = props
  const { mutate, isLoading, ...rest } = useMutation(deleteAttachment, { onSuccess, onError })

  return { delete: mutate, isProcessing: isLoading, ...rest }
}
